import script from "./RankingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RankingTable.vue?vue&type=script&setup=true&lang=js"

import "./RankingTable.vue?vue&type=style&index=0&id=c21bbd38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c21bbd38"]])

export default __exports__